<template>
	<div :style="{ width: sidebarWidth }" class="sidebar">
		<span
			v-if="collapsedIconVisibility"
			:class="{ 'rotate-180': collapsed }"
			class="sidebar__collapse-icon"
			@click="toggleSidebar"
		>
			<svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M11.3183 15.5024C11.4608 15.5024 11.6033 15.4499 11.7158 15.3374C11.9333 15.1199 11.9333 14.7599 11.7158 14.5424L6.82578 9.65239C6.46578 9.29239 6.46578 8.70739 6.82578 8.34739L11.7158 3.45739C11.9333 3.23989 11.9333 2.87989 11.7158 2.66239C11.4983 2.44489 11.1383 2.44489 10.9208 2.66239L6.03078 7.55239C5.64828 7.93489 5.43078 8.45239 5.43078 8.99989C5.43078 9.54739 5.64078 10.0649 6.03078 10.4474L10.9208 15.3374C11.0333 15.4424 11.1758 15.5024 11.3183 15.5024Z"
					fill="#999999"
				/>
			</svg>
		</span>

		<div class="sidebar__content">
			<div v-if="collapsed" class="sidebar__logo">
				<img alt="" src="/images/img/logo_letter_32px.svg" />
			</div>
			<div v-else class="sidebar__logo">
				<img alt="" src="/images/img/logo_letter_32px.svg" />
				<img alt="" src="/images/img/logo_txt.svg" width="120" />
			</div>
		</div>

		<SidebarLink
			v-if="this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.id"
			:link="{
				name: 'Profile',
				params: { id: this.$store.getters.getCurrentUser.id },
				class: 'profile',
			}"
			:logout="logout"
			:to="`/profile/${this.$store.getters.getCurrentUser.id}`"
			name="Профиль"
		>
			<slot v-if="avatar === ' ' || avatar === '' || avatar === null">
				<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.5"
					/>
					<path
						d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.5"
					/>
				</svg>
			</slot>
			<slot v-else>
				<div class="sidebar__avatar">
					<Img :cache="false" :lazy="true" :size="32" :src="avatar" alt="avatar" classname="avatar" />
				</div>
			</slot>
		</SidebarLink>

		<SidebarLink :link="{ name: 'TaskListIncoming' }" :showCount="true" name="Входящие" to="/task/">
			<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
				<path
					d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
			</svg>
		</SidebarLink>

		<SidebarLink :link="{ name: 'TaskList' }" name="Все задачи" to="/task-incoming/">
			<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</svg>
		</SidebarLink>

		<SidebarLink :link="{ name: 'FormList' }" name="Формы" to="/form/">
			<form-list-svg />
		</SidebarLink>

		<SidebarLink :link="{ name: 'CatalogList' }" name="Справочники" to="/catalog/">
			<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
				<path
					d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
				<path
					d="M8 13H12"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
				<path
					d="M8 17H16"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
			</svg>
		</SidebarLink>

		<SidebarLink :link="{ name: 'Company' }" name="Компания" to="/company/">
			<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.0001 8.16C17.9401 8.15 17.8701 8.15 17.8101 8.16C16.4301 8.11 15.3301 6.98 15.3301 5.58C15.3301 4.15 16.4801 3 17.9101 3C19.3401 3 20.4901 4.16 20.4901 5.58C20.4801 6.98 19.3801 8.11 18.0001 8.16Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M16.9695 15.4399C18.3395 15.6699 19.8495 15.4299 20.9095 14.7199C22.3195 13.7799 22.3195 12.2399 20.9095 11.2999C19.8395 10.5899 18.3095 10.3499 16.9395 10.5899"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M5.96852 8.16C6.02852 8.15 6.09852 8.15 6.15852 8.16C7.53852 8.11 8.63852 6.98 8.63852 5.58C8.63852 4.15 7.48852 3 6.05852 3C4.62852 3 3.47852 4.16 3.47852 5.58C3.48852 6.98 4.58852 8.11 5.96852 8.16Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M6.99945 15.4399C5.62945 15.6699 4.11945 15.4299 3.05945 14.7199C1.64945 13.7799 1.64945 12.2399 3.05945 11.2999C4.12945 10.5899 5.65945 10.3499 7.02945 10.5899"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M12.0001 14.63C11.9401 14.62 11.8701 14.62 11.8101 14.63C10.4301 14.58 9.33008 13.45 9.33008 12.05C9.33008 10.62 10.4801 9.47 11.9101 9.47C13.3401 9.47 14.4901 10.63 14.4901 12.05C14.4801 13.45 13.3801 14.59 12.0001 14.63Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					d="M9.0907 17.78C7.6807 18.72 7.6807 20.26 9.0907 21.2C10.6907 22.27 13.3107 22.27 14.9107 21.2C16.3207 20.26 16.3207 18.72 14.9107 17.78C13.3207 16.72 10.6907 16.72 9.0907 17.78Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</svg>
		</SidebarLink>

		<SidebarLink
			v-if="getStatusAccessForRO()"
			:link="{ name: 'RegistryOutsources' }"
			name="Реестр Аутсорсов"
			to="/registry-outsources"
		>
			РА
		</SidebarLink>

		<SidebarLink 
		v-if="getStatusAccessForInstallerSchedule()"
		 :link="{ name: 'InstallerSchedule' }" name="Расписание" :to="getRouteInstallerScheduleTable()">
			<NIcon color="var(&#45;&#45;white)" size="20">
				<CalendarIcon />
			</NIcon>
		</SidebarLink>

		<SidebarLink
		 :link="{ name: 'RpaPage' }" name="PPA" to="/ppa/" >
		 <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  			<path 
				d="M7.49984 18.3327H12.4998C16.6665 18.3327 18.3332 16.666 18.3332 12.4993V7.49935C18.3332 3.33268 16.6665 1.66602 12.4998 1.66602H7.49984C3.33317 1.66602 1.6665 3.33268 1.6665 7.49935V12.4993C1.6665 16.666 3.33317 18.3327 7.49984 18.3327Z"
			 	stroke="currentColor" 
				stroke-width="1.5" 
				stroke-linecap="round" 
				stroke-linejoin="round" 
			/>
  			<path 
				d="M18.3332 8.33398H1.6665" 
				stroke="currentColor" 
				stroke-width="1.5" 
				stroke-linecap="round" 
				stroke-linejoin="round" 
			/>
  			<path 
				d="M10 8.33398V18.334" 
				stroke="currentColor" 
				stroke-width="1.5" 
				stroke-linecap="round" 
				stroke-linejoin="round" 
				/>
		  </svg>
		</SidebarLink>
		<SidebarLink
		v-if="getStatusAccessForPasswordFunc()"
		 :link="{ name: 'resetPassword' }" name="Сброс пароля" to="/reset-password/" >
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M9 11V10C9 8.34 9.5 7 12 7C14.5 7 15 8.34 15 10V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 14.6C12.3314 14.6 12.6 14.3314 12.6 14C12.6 13.6687 12.3314 13.4 12 13.4C11.6686 13.4 11.4 13.6687 11.4 14C11.4 14.3314 11.6686 14.6 12 14.6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M14.5 17H9.5C7.5 17 7 16.5 7 14.5V13.5C7 11.5 7.5 11 9.5 11H14.5C16.5 11 17 11.5 17 13.5V14.5C17 16.5 16.5 17 14.5 17Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</SidebarLink>
	</div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";

import { getRouteInstallerScheduleTable } from "@/shared/const/router";

import Img from "@/components/ui/Img/Img.vue";
import SidebarLink from "@/components/ui/sidebarLink.vue";
import formListSvg from "@/components/ui/svg/formListSvg.vue";
import { collapsed, collapsedIconVisibility, sidebarWidth, toggleSidebar } from "@/core/sidebarState";
import globalStore from "@/core/store/globalStore";
import { urlForDownload } from "@/core/utils";
import { getStatusAccessForRO, getStatusAccessForInstallerSchedule, getStatusAccessForPasswordFunc } from "@/helpers/userAccess";
import CalendarIcon from "@/shared/assets/icons/CalendarIcon";
import { NIcon } from "naive-ui";

export default defineComponent({
	name: "sidebar",
	methods: { getRouteInstallerScheduleTable, getStatusAccessForRO, getStatusAccessForInstallerSchedule, getStatusAccessForPasswordFunc, urlForDownload },
	components: { formListSvg, SidebarLink, Img, NIcon, CalendarIcon },
	setup(_, ctx) {
		const logout = () => {
			ctx.emit("resetApp", "logout-link");
		};

		const route = useRoute();
		const isActive = computed(() => route.path === "/login/");
		return {
			collapsed,
			toggleSidebar,
			sidebarWidth,
			logout,

			isActive,
			collapsedIconVisibility,
		};
	},
	computed: {
		avatar() {
			return urlForDownload(this.$store.getters.getCurrentUserInfo.avatar_url, 64);
		},
	},
	watch: {
		collapsed() {
			globalStore.dispatch("setIsCollapseMenu", collapsed.value);
		},
	},
});
</script>

<style scoped>
.sidebar {
	float: left;

	position: relative;

	display: flex;
	flex-direction: column;

	padding: 10px;

	z-index: 2;

	transition: 0.3s;

	color: white;
	background: var(--primary);
	font-family: Inter, sans-serif;
}

.dark .sidebar {
	background: var(--dark-bg-800);
}

.sidebar__content {
	margin-bottom: 12px;
}

.sidebar__logo {
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 768px) {
		justify-content: start;
		padding-left: 10px;
	}
}

.sidebar__collapse-icon {
	position: absolute;
	top: 50%;
	left: 100%;
	transform: translateX(-50%);

	display: flex;
	align-items: center;
	justify-content: center;

	content: "";
	cursor: pointer;
	transition: 0.2s linear;

	width: 26px;
	height: 26px;

	border-radius: 50%;
	background-color: #fff;

	@media (max-width: 768px) {
		display: none;
	}
}

.dark .sidebar__collapse-icon {
	background: var(--dark-bg-700);
}

.dark .sidebar__collapse-icon svg path {
	fill: var(--text-color);
}

.sidebar__avatar {
	width: 32px;
	height: 32px;

	display: flex;
	align-items: center;

	border-radius: 50%;
}

.rotate-180 {
	transform: rotate(180deg) translateX(50%);
	transition: 0.2s linear;
}

.link {
	display: flex;
	align-items: center;

	padding: 10px 0 10px 12px;
	margin-bottom: 6px;

	transition: all 0.4s;
	white-space: nowrap;

	border-radius: 6px;
	color: white;
	cursor: pointer;
}

.link.collapsed {
	transition-delay: 0.2s;
	justify-content: center;
	padding: 10px 10px 12px;
}

.link:hover {
	background-color: rgba(255, 255, 255, 0.2);
}

.link svg {
	color: var(--color-side-icon);
}

.link.active svg {
	color: var(--color-side-icon-active);
}

.link.active {
	background-color: white;
	color: #333333;
}

.link span {
	margin-left: 10px;

	line-height: 120%;

	white-space: nowrap;
}

.link.collapsed:has(img) {
	width: 100%;
	padding: 10px 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.link.collapsed img {
	margin-left: -1px;
}

.link svg {
	flex-shrink: 0;
	width: 20px;
	height: 20px;
}

.link.active svg path {
	color: #333333;
}

.footer {
	margin-top: auto;
}

.sidebar__avatar {
	width: 32px;
	height: 32px;
}
</style>
